var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9827 9.14998L32.0567 57.299C31.5003 58.2933 30.072 58.2989 29.5081 57.3103L2.04781 9.1556C1.43234 8.07654 2.35344 6.77107 3.5764 6.98904L30.5314 11.8064C30.7034 11.8378 30.8797 11.8378 31.0517 11.8064L57.4423 6.99654C58.6602 6.77482 59.5869 8.06951 58.9827 9.14998Z",
    fill: "url(#paint0_linear_1159_2555)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5859 1.16797C43.6049 1.17418 43.623 1.1826 43.6396 1.19336L43.6846 1.23145C43.6979 1.24602 43.7096 1.26197 43.7188 1.2793L43.7393 1.33496C43.7438 1.35425 43.7456 1.37392 43.7451 1.39355L43.7363 1.45215V1.45312L40.0098 14.3711C39.9656 14.5229 39.9511 14.6815 39.9668 14.8379L39.9922 14.9932C40.028 15.1473 40.0933 15.2931 40.1836 15.4219L40.2822 15.5449C40.3888 15.6616 40.5166 15.7562 40.6582 15.8242L40.8047 15.8838C41.0048 15.95 41.2189 15.9631 41.4258 15.9229L41.4248 15.9219L47.1367 14.8203C47.3003 14.7886 47.4359 14.9342 47.4092 15.0869L47.3877 15.1523L47.3867 15.1533L31.1592 47.5371L30.8838 47.9639C30.8403 48.0311 30.7944 48.0553 30.7568 48.0654C30.7131 48.0772 30.6575 48.0747 30.6016 48.0518C30.5456 48.0288 30.5044 47.9913 30.4814 47.9521C30.4618 47.9185 30.446 47.8691 30.4619 47.791L33.082 35.1123H33.083C33.2588 34.2556 32.5153 33.5107 31.6846 33.6445L31.5166 33.6836L28.0908 34.7256C28.0525 34.7372 28.0117 34.7393 27.9727 34.7305C27.9532 34.7261 27.9345 34.719 27.917 34.71L27.8672 34.6758C27.8524 34.6623 27.8399 34.6465 27.8291 34.6299L27.8027 34.5762C27.7903 34.5382 27.7881 34.4972 27.7959 34.458L29.4443 26.3867C29.4857 26.1847 29.4765 25.9755 29.416 25.7783C29.3706 25.6304 29.2979 25.4925 29.2021 25.3721L29.0986 25.2578C28.9878 25.1496 28.8577 25.0637 28.7158 25.0039L28.5703 24.9531C28.4213 24.9113 28.2663 24.8985 28.1133 24.9141L27.9619 24.9385H27.9609L22.4131 26.2207C22.3957 26.2246 22.378 26.2267 22.3604 26.2266L22.3066 26.2197C22.289 26.2154 22.2719 26.2094 22.2559 26.2012L22.2109 26.1719C22.1973 26.1604 22.1854 26.147 22.1748 26.1328L22.1475 26.0859C22.1333 26.0531 22.127 26.0172 22.1289 25.9814L23.3564 5.27734L23.3555 5.27637C23.3571 5.25133 23.3636 5.22702 23.373 5.2041L23.4131 5.13965C23.43 5.12038 23.4498 5.1044 23.4717 5.0918L23.542 5.06445H23.543L43.4678 1.16113H43.4688C43.4884 1.15723 43.5085 1.15504 43.5283 1.15625L43.5859 1.16797Z",
    fill: "url(#paint1_linear_1159_2555)",
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1159_2555",
    x1: 1.85156,
    y1: 32.5066,
    x2: 59.1724,
    y2: 32.5066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1159_2555",
    x1: 21.6289,
    y1: 24.6144,
    x2: 47.9137,
    y2: 24.6144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVite);
export default __webpack_public_path__ + "static/media/vite.976df650bb53e07f69fced63c91ace57.svg";
export { ForwardRef as ReactComponent };